<template>
    <div>
        <vue-headful :title="`${this.reminder_id ? 'Edit' : 'Create'} Inspection Goal :: MeritEHS`"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <template v-if="this.reminder.role_id">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/admin/roles">
                            <i class="fa fa-lock"></i> Roles
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/admin/role-edit/${this.reminder.role_id}`">
                            {{ this.reminder.role_name }}
                        </router-link>
                    </li>
                </template>
                <template v-else-if="this.reminder.user_id != null && this.reminder.user_id !== this.$store.state.user.UserId">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/users">
                            <i class="fa fa-user"></i> Users
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/users/view/${this.reminder.user_id}`">
                            {{ this.reminder.FirstName }} {{ this.reminder.LastName }}
                        </router-link>
                    </li>
                </template>
                <template v-else>
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/profile">
                        <i class="fa fa-user"></i> Profile
                    </router-link>
                </li>
                </template>
                <li class="breadcrumb-item active"><span v-if="this.reminder_id">Edit</span><span v-else>Create</span> Inspection Goal</li>
            </ol>
        </h4>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(this.reminder_id ? 'Edit' : 'Create') + ' Inspection Reminder :: MeritEHS'" />

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card mb-4" v-if="this.$store.state.user.is_admin && this.reminder.user_id">
                        <div class="card-header">Select a User <i class="fa fa-asterisk text-danger small"></i></div>
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.user_id }" class="row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.user_id }">User:</label>
                                <div class="col-sm-8">
                                    <user-select :selectedValues="userSelectValues" @vuselected="onUserSelectUpdate" :hasError="errors.user_id ? true : false"></user-select>
                                    <span v-if="errors.user_id" class="text-danger">
                                        <span v-for="error in errors.user_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.role_id }" class="row" v-if="false">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.role_id }">Role:</label>
                                <div class="col-sm-8">
                                    <b-form-select v-model="reminder.role_id" :options="roleOptions" :class="{'is-invalid': errors.role_id}"></b-form-select>

                                    <span v-if="errors.role_id" class="text-danger">
                                        <span v-for="error in errors.role_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">Goal Details</div>
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.inspection_form_id }" class="row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.inspection_form_id }">Inspection Form:</label>
                                <div class="col-sm-8">
                                    <select v-model="reminder.inspection_form_id" class="form-control" :class="{'is-invalid': errors.inspection_form_id}">
                                        <option :value="null">-- Select an inspection form --</option>
                                        <option v-for="form in forms" :value="form.inspection_form_id">{{ form.form_name }}</option>
                                    </select>
                                    <span v-if="errors.inspection_form_id" class="text-danger">
                                        <span v-for="error in errors.inspection_form_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.goal || errors.repeat_amount || errors.repeat_interval || errors.goal_time }" class="row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.goal || errors.repeat_amount || errors.repeat_interval || errors.goal_time }">Goal: <i class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">
                                    <div class="mb-1">
                                        <div class="form-inline">
                                            <label class="col-form-label mr-1">Complete</label>

                                            <b-input placeholder="1" style="width: 75px;" v-model="reminder.goal" :class="{'is-invalid': errors.goal}" type="number" />

                                            <label class="col-form-label mx-1"> inspection(s)</label>
                                        </div>
                                    </div>
                                    <div class="form-inline">
                                        <label class="col-form-label mx-1">Every</label>

                                        <b-input style="width: 75px;" placeholder="1" v-model="reminder.repeat_amount" class="mr-1" :class="{'is-invalid': errors.repeat_amount}" type="number" />

                                        <select style="width: 100px;" v-model="reminder.repeat_interval" class="form-control" :class="{'is-invalid': errors.repeat_interval}" @change="resetExtras()">
                                            <option value="day">day(s)</option>
                                            <option value="week">week(s)</option>
                                            <option value="month">month(s)</option>
                                        </select>

                                        <label class="col-form-label mx-1">by</label>

                                        <date-picker placeholder="5:00 PM" style="width: 100px;" :value="readTime(reminder.goal_time)" @input="reminder.goal_time = writeTime($event)" :config="time_options" :class="{'is-invalid': errors.goal_time}"></date-picker>
                                    </div>

                                    <div v-if="errors.goal" class="text-danger">
                                        <span v-for="error in errors.goal">{{ error }}</span>
                                    </div>
                                    <div v-if="errors.repeat_amount" class="text-danger">
                                        <span v-for="error in errors.repeat_amount">{{ error }}</span>
                                    </div>
                                    <div v-if="errors.repeat_interval" class="text-danger">
                                        <span v-for="error in errors.repeat_interval">{{ error }}</span>
                                    </div>
                                    <div v-if="errors.goal_time" class="text-danger">
                                        <span v-for="error in errors.goal_time">{{ error }}</span>
                                    </div>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.next_goal }" class="row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.next_goal }">Next goal: <i class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">
                                    <date-picker :value="readDate(reminder.next_goal)" @input="reminder.next_goal = writeDate($event)" :config="date_options" :disabled="!reminder.repeat_amount"></date-picker>
                                    <span v-if="errors.next_goal" class="text-danger">
                                        <span v-for="error in errors.next_goal">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.goal }" class="row">
                                <template v-if="reminder.repeat_interval == 'day'">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors['interval_extra.include_weekends'] }">Include weekends?:</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="include_weekends" :value="1" :unchecked-value="0" plain :class="{'is-invalid': errors['interval_extra.include_weekends'] }" />
                                        <span v-if="errors['interval_extra.include_weekends']" class="text-danger">
                                            <span v-for="error in errors['interval_extra.include_weekends']">{{ error }}</span>
                                        </span>
                                    </div>
                                </template>
                                <!-- We can figure out the day of the week/month based on the next_goal that they set -->
                                <!-- <template v-if="reminder.repeat_interval == 'week'">
                                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">Day of week: <i class="fa fa-asterisk text-danger small"></i></label>
                                    <div class="col-sm-8">
                                        <b-input placeholder="Monday" v-model="week_extra.day_of_week" class="mr-1" :class="{'is-invalid': errors.interval_extra}" />
                                        <small>Allowed formats are full name (Thursday) or 3 letter name (Thu)</small>
                                    </div>
                                </template> -->
                                <!-- <template v-if="reminder.repeat_interval == 'month'">
                                    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors['interval_extra.day_of_month'] }">Day of month: <i class="fa fa-asterisk text-danger small"></i></label>
                                    <div class="col-sm-8">
                                        <b-input placeholder="1" v-model="reminder.interval_extra.day_of_month" class="mr-1" :class="{'is-invalid': errors['interval_extra.day_of_month'] }" />
                                        <small>If a given month doesn't have the specified day, the last day of the month will be used.</small>
                                        <div v-if="errors['interval_extra.day_of_month']" class="text-danger">
                                            <span v-for="error in errors['interval_extra.day_of_month']">{{ error }}</span>
                                        </div>
                                    </div>
                                </template> -->
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4 mb-2">
                        <div class="card-header">
                            Email Alerts <b-button size="sm" variant="success" @click="newReminder()" title="New Reminder"><i class="fa fa-plus-circle"></i></b-button>
                        </div>
                        <div class="card-body">
                            <div v-for="(item, index) in reminder.reminders">
                                <hr v-if="index > 0">
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors['reminders.'+index+'.goal'] || errors['reminders.'+index+'.repeat_amount'] || errors['reminders.'+index+'.time'] }" class="row">
                                    <div :class="{ 'col-12 mb-2': true, 'text-danger': errors['reminders.'+index+'.goal'] || errors['reminders.'+index+'.repeat_amount'] || errors['reminders.'+index+'.time'] }">
                                        <b-button variant="light" size="xs" @click="reminder.reminders.splice(index, 1)" title="Delete Reminder"><i class="fa fa-trash text-danger"></i></b-button>
                                        <label class="col-form-label">Send a Reminder if: <i class="fa fa-asterisk text-danger small"></i></label>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-inline">
                                            <b-input placeholder="1" style="width: 75px;" v-model="item.goal" :class="{'is-invalid': errors['reminders.'+index+'.goal']}" type="number" />

                                            <label class="col-form-label mx-1"> inspection(s) not completed by </label>

                                            <date-picker placeholder="5:00 PM" style="width: 100px;" :value="readTime(item.time)" @input="item.time = writeTime($event)" :config="time_options" :class="{'is-invalid': errors['reminders.'+index+'.time']}"></date-picker>

                                            <select style="width: 150px;" v-model="item.repeat_amount" class="ml-1 form-control" :class="{'is-invalid': errors['reminders.'+index+'.repeat_amount']}">
                                                <option v-for="option in intervalSelectOptions" :value="option.value">{{ option.label }}</option>
                                            </select>
                                        </div>

                                        <div v-if="errors['reminders.'+index+'.goal']" class="text-danger">
                                            <span v-for="error in errors['reminders.'+index+'.goal']">{{ error }}</span>
                                        </div>
                                        <div v-if="errors['reminders.'+index+'.repeat_amount']" class="text-danger">
                                            <span v-for="error in errors['reminders.'+index+'.repeat_amount']">{{ error }}</span>
                                        </div>
                                        <div v-if="errors['reminders.'+index+'.time']" class="text-danger">
                                            <span v-for="error in errors['reminders.'+index+'.time']">{{ error }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <template v-if="reminder.repeat_interval == 'week'">
                                        <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors['reminders.'+index+'.interval_extra.day_of_week'] }">Day of week: <i class="fa fa-asterisk text-danger small"></i></label>
                                        <div class="col-sm-8">
                                            <b-input placeholder="Monday" v-model="item.interval_extra.day_of_week" class="mr-1" :class="{'is-invalid': errors['reminders.'+index+'.interval_extra.day_of_week'] }" />
                                            <small>Allowed formats are full name (Thursday) or 3 letter name (Thu)</small>
                                            <div v-if="errors['reminders.'+index+'.interval_extra.day_of_week']" class="text-danger">
                                                <span v-for="error in errors['reminders.'+index+'.interval_extra.day_of_week']">{{ error }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="reminder.repeat_interval == 'month'">
                                        <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors['reminders.'+index+'.interval_extra.day_of_month'] }">Day of month: <i class="fa fa-asterisk text-danger small"></i></label>
                                        <div class="col-sm-8">
                                            <b-input placeholder="1" v-model="item.interval_extra.day_of_month" class="mr-1" :class="{'is-invalid': errors['reminders.'+index+'.interval_extra.day_of_month'] }" />
                                            <small>If a given month doesn't have the specified day, the last day of the month will be used.</small>
                                            <div v-if="errors['reminders.'+index+'.interval_extra.day_of_month']" class="text-danger">
                                                <span v-for="error in errors['reminders.'+index+'.interval_extra.day_of_month']">{{ error }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="button" class="btn btn-success" v-on:click="saveReminder()" :disabled="saving">
                        <span v-if="this.reminder_id">Update</span><span v-else>Create</span> Inspection Reminder
                    </button>
                </div>
                <div class="col-lg-4 col-12 mt-lg-0 mt-4">
                    <div class="card">
                        <div class="card-header">
                            Basic Examples
                        </div>
                        <div class="card-body">
                            <h5 class="mb-2">Daily Inspections</h5>
                            To be reminded at 4:00 PM daily for inspections, set the goal to "Complete 1 inspection(s) every 1 day(s) by 5:00 PM", then add an alert to send a reminder if "1 inspection(s) not completed by 4:00 PM the next day."
                            <h5 class="mb-2 mt-4">Weekly Inspections</h5>
                            To be reminded every Wednesday at noon and Saturday at 4:00 PM for weekly inspections, set the goal to "Complete 2 inspection(s) every 1 week(s) by 5:00 PM", then add two alerts. The first would be "1 inspection(s) not completed by 12:00 PM within 1 week on Wednesday." and the second would be "2 inspection(s) not completed by 4:00 PM after 1 week on Saturday."
                            <h5 class="mt-4" v-if="false">Monthly Inspections</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                include_weekends: 0,
                reminder_id: this.$route.params.id,
                reminder: {},
                forms: [],
                roles: [],
                errors: {},
                userTimezone: this.$store.state.user.timezone,
                date_options: {
                    format: 'MM/DD/YYYY',
                    minDate: moment().startOf('day'), // now
                    maxDate: null,
                },
                time_options: {
                    format: 'LT',
                    stepping: 5,
                    timeZone: this.$store.state.user.timezone,
                },
            }
        },

        watch: {
            repeatAmountWatcher(newValue, oldValue){
                this.date_options.maxDate = moment().add(newValue, this.reminder.repeat_interval);
            },

            repeatIntervalWatcher(newValue, oldValue){
                this.date_options.maxDate = moment().add(this.reminder.repeat_amount, newValue);

                // When this gets changed, change the "default" next goal
                setTimeout(() => {
                    this.$set(this.reminder, 'next_goal', moment().endOf(this.reminder.repeat_interval).format('YYYY-MM-DD'));
                }, 1);
            },
        },

        computed: {
            repeatAmountWatcher() {
                return this.reminder.repeat_amount;
            },

            repeatIntervalWatcher() {
                return this.reminder.repeat_interval;
            },

            userSelectValues(){
                //Check for null
                if((!this.reminder.user_id || this.reminder.user_id == null) && !this.reminder.role_id)
                {
                    this.reminder.user_id = this.$store.state.user.user_id;
                    return { UserId: this.$store.state.user.user_id, FirstName: this.$store.state.user.first_name, LastName: this.$store.state.user.last_name };
                }
                else if(this.reminder.role_id)
                {
                    return null;
                }

                //Send it
                return { UserId: this.reminder.user_id, FirstName: this.reminder.FirstName, LastName: this.reminder.LastName};
            },

            // Builds words for the values to make the intervals clearer to users
            intervalSelectOptions() {
                let repeat_interval = this.reminder.repeat_interval;
                let options = [];

                if (repeat_interval === 'day')
                {
                    options.push({
                        label: 'the same day',
                        value: 0,
                    });
                    options.push({
                        label: 'the next day',
                        value: 1,
                    });

                    for (let i = 2; i <= this.reminder.repeat_amount; i++) {
                        options.push({
                            label: `after ${i} days`,
                            value: i,
                        })
                    }
                }
                else
                {
                    options.push({
                        label: `within 1 ${repeat_interval}`,
                        value: 0,
                    })

                    if (this.reminder.repeat_amount > 0)
                    {
                        options.push({
                            label: `after 1 ${repeat_interval}`,
                            value: 1,
                        });
                    }

                    for (let i = 2; i <= this.reminder.repeat_amount; i++)
                    {
                        options.push({
                            label: `after ${i} ${repeat_interval}s`,
                            value: i,
                        });
                    }
                }

                return options;
            },

            roleOptions(){
                //Setup
                var options = [
                    {value: null, text: '-- Select a Role --'},
                ];

                //Loop through and build lists
                for(var i = 0; i < this.roles.length; i++)
                {
                    //Push onto options
                    options.push({value: this.roles[i].id, text: this.roles[i].name});
                }

                //Send it
                return options;
            },
        },

        methods: {
            onUserSelectUpdate (user){
                //Check for null
                if(user == null)
                {
                    this.reminder.user_id = null
                    return;
                }

                //Set it
                this.reminder.user_id = user.UserId;
            },

            newReminder() {
                this.reminder.reminders.push({interval_extra: {}, repeat_amount: 0});
            },

            // Convert database timezone/format to human
            readTime(time) {
                return moment(time, 'HH:mm:ss').tz(this.userTimezone);
            },

            // Convert human timezone/format to database
            writeTime(time) {
                return moment.tz(time, 'LT', this.userTimezone).utc().format('HH:mm');
            },

            // Convert database date to human
            readDate(date) {
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            },

            // Convert human date to database
            writeDate(date) {
                return moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
            },

            getReminder(){
                //Send it
                this.$http.get('profile/reminders/edit' + (this.reminder_id ? `/${this.reminder_id}` : ''), {user_id: this.$route.query.user_id, role_id: this.$route.query.role_id})
                    .then(res => {
                        //Set it
                        this.reminder = res.data.reminder;
                        this.reminder.reminders = JSON.parse(this.reminder.reminders);
                        this.forms = res.data.forms;
                        this.roles = res.data.roles;

                        //Create a New one
                        if(!this.reminder.inspection_reminder_id)
                        {
                            //Create a New One
                            this.newReminder();
                        }
                    })
                    .then(() => {
                        //Set flag
                        this.loading = false;
                    });
            },

            resetExtras: function() {
                switch (this.reminder.repeat_interval)
                {
                    case 'day':
                        this.reminder.interval_extra = {include_weekends: 0};
                        break;
                    case 'week':
                        this.reminder.interval_extra = {};
                        break;
                    case 'month':
                        this.reminder.interval_extra = {day_of_month: null};
                        break;
                    default:
                        break;
                }

                for (let i = 0; i < this.reminder.reminders.length; i++)
                {
                    switch (this.reminder.repeat_interval)
                    {
                        case 'day':
                            this.reminder.reminders[i].interval_extra = {};
                            break;
                        case 'week':
                            this.reminder.reminders[i].interval_extra = {day_of_week: ''}
                            break;
                        case 'month':
                            this.reminder.reminders[i].interval_extra = {day_of_month: null};
                            break;
                        default:
                            break;
                    }
                }
            },

            saveReminder: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Set some values
                if(this.include_weekends == 1)
                {
                    //Setup
                    this.reminder.interval_extra = {};
                    this.reminder.interval_extra['include_weekends'] = 1;
                }

                //Send it
                this.$http
                .post('profile/reminders/edit' + (this.reminder_id ? `/${this.reminder_id}` : ''), this.reminder)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Reminder Saved');

                    //Check for values
                    if(this.reminder.role_id)
                    {
                        //Return to main list?
                        this.$router.push('/admin/role-edit/' + this.reminder.role_id);
                    }
                    else if (this.reminder.user_id && this.reminder.user_id != this.$store.state.user.UserId)
                    {
                        //Return to main list?
                        this.$router.push('/users/view/'+this.reminder.user_id);
                    }
                    else
                    {
                        //Return to main list?
                        this.$router.push('/profile');
                    }

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted(){
            //Get the users jobsite
            this.getReminder();
        }
    }
</script>
